import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AleAndPaul from '../../assets/ale-and-paul.webp';
import howToTakeVideo from '../../assets/how-to-take.mp4';
import ritualImg2 from '../../assets/ritual-step-2.webp';
import ritualImg3 from '../../assets/ritual-step-3.webp';
import ritualImg4 from '../../assets/ritual-step-4.webp';
import './HowToTake.css';
import {
  HowToEnjoy_Step1_Title,
  HowToEnjoy_Step1_Desc,
  HowToEnjoy_Step2_Title,
  HowToEnjoy_Step2_Desc,
  HowToEnjoy_Step3_Title,
  HowToEnjoy_Step3_Desc,
  HTT_Eyebrow,
  HTT_Headline,
  HTT_Subhead,
  HTT_Rule_No,
  HTT_Rule_Yes,
  HTT_Rule_Why,
  HTT_Rule_Alt,
  HTT_Rule_Crunch,
  HTT_Rule_CrunchWhy,
  HTT_VideoYoghurt,
  HTT_StepOf,
  HTT_Done,
  HTT_VideoTitle,
  HTT_TL_VideoEyebrow,
  HTT_TL_VideoTitle,
  HTT_StepsTitle,
  HTT_Consistency,
  HTT_FoundersEyebrow,
  HTT_FoundersMessage,
  HTT_FoundersSignature,
  HTT_CheckinEyebrow,
  HTT_CheckinTitle,
  HTT_CheckinBody,
  HTT_CheckinCTA,
  HTT_Support,
  HTT_Ritual_CheckinEyebrow,
  HTT_Ritual_CheckinTitle,
  HTT_Ritual_CheckinBody,
  HTT_Ritual_CheckinBtn,
  HTT_Step2_Label,
  HTT_Step3_Label,
  HTT_Step4_Label,
  HTT_TL_Eyebrow,
  HTT_TL_Headline,
  HTT_TL_W1_Period, HTT_TL_W1_Title, HTT_TL_W1_Body,
  HTT_TL_M1_Period, HTT_TL_M1_Title, HTT_TL_M1_Body,
  HTT_TL_M3_Period, HTT_TL_M3_Title, HTT_TL_M3_Body,
  HTT_TL_M6_Period, HTT_TL_M6_Title, HTT_TL_M6_Body,
  HTT_Concept_Eyebrow,
  HTT_Concept_Headline,
  HTT_Brain_TagLeft,
  HTT_Brain_PctLeft,
  HTT_Brain_TitleLeft,
  HTT_Brain_BodyLeft,
  HTT_Brain_TagRight,
  HTT_Brain_PctRight,
  HTT_Brain_TitleRight,
  HTT_Brain_BodyRight,
  HTT_Brain_Insight,
  HTT_Habit_Eyebrow,
  HTT_Habit_Headline,
  HTT_Habit_Intro,
  HTT_Habit_1_Num,
  HTT_Habit_1_Title,
  HTT_Habit_1_Body,
  HTT_Habit_1_Note,
  HTT_Habit_2_Num,
  HTT_Habit_2_Title,
  HTT_Habit_2_Body,
  HTT_Habit_2_Note,
  HTT_Habit_3_Num,
  HTT_Habit_3_Title,
  HTT_Habit_3_Body,
  HTT_Habit_3_Note,
  HTT_FAQ_Eyebrow,
  HTT_FAQ_Headline,
  HTT_FAQ_Cat_1,
  HTT_FAQ_Cat_2,
  HTT_FAQ_Cat_3,
  HTT_FAQ_Cat_4,
  HTT_FAQ_Contact,
  HTT_FAQ_1_Q, HTT_FAQ_1_A,
  HTT_FAQ_2_Q, HTT_FAQ_2_A,
  HTT_FAQ_3_Q, HTT_FAQ_3_A,
  HTT_FAQ_4_Q, HTT_FAQ_4_A,
  HTT_FAQ_5_Q, HTT_FAQ_5_A,
  HTT_FAQ_6_Q, HTT_FAQ_6_A,
  HTT_FAQ_7_Q, HTT_FAQ_7_A,
} from '../../Constants';

const CHECKIN_URL = 'https://www.weriise.co/customer/checkin';

const FAQ_ITEMS = [
  { cat: 0, qKey: HTT_FAQ_2_Q, aKey: HTT_FAQ_2_A },
  { cat: 0, qKey: HTT_FAQ_4_Q, aKey: HTT_FAQ_4_A },
  { cat: 0, qKey: HTT_FAQ_5_Q, aKey: HTT_FAQ_5_A },
  { cat: 1, qKey: HTT_FAQ_3_Q, aKey: HTT_FAQ_3_A },
  { cat: 2, qKey: HTT_FAQ_7_Q, aKey: HTT_FAQ_7_A },
  { cat: 3, qKey: HTT_FAQ_6_Q, aKey: HTT_FAQ_6_A },
];

const TL_MILESTONES = [
  { period: HTT_TL_W1_Period, title: HTT_TL_W1_Title, body: HTT_TL_W1_Body },
  { period: HTT_TL_M1_Period, title: HTT_TL_M1_Title, body: HTT_TL_M1_Body },
  { period: HTT_TL_M3_Period, title: HTT_TL_M3_Title, body: HTT_TL_M3_Body },
  { period: HTT_TL_M6_Period, title: HTT_TL_M6_Title, body: HTT_TL_M6_Body },
];

// Graph dot positions — exponential curve: nearly flat start, steep finish
// viewBox 0 0 800 95, baseline y=91
const TL_DOTS = [
  { cx: 100, cy: 87 },  // Week 1
  { cx: 300, cy: 83 },  // Month 1
  { cx: 500, cy: 58 },  // Month 3
  { cx: 700, cy:  9 },  // Month 6+
];

// Desktop vertical graph: viewBox 0 0 120 544, one 136px row per milestone
const TL_DOTS_V = [
  { cx:  14, cy:  68 },  // Week 1
  { cx:  24, cy: 204 },  // Month 1
  { cx:  52, cy: 340 },  // Month 3
  { cx: 104, cy: 476 },  // Month 6+
];

// Mobile: viewBox 0 0 400 150 — fills full mobile width, no horizontal compression
const TL_DOTS_MOBILE = [
  { cx:  50, cy: 135 },
  { cx: 150, cy: 129 },
  { cx: 250, cy:  90 },
  { cx: 350, cy:  15 },
];

// Explainer video for the timeline section. Recorded in German only, so it is hidden for other languages.
const TL_VIDEO_DE = 'https://d1ypa02v8rscne.cloudfront.net/resources/videos/philipp-erklaervideo-de-v2-how%20to%20(1).mp4';

const HowToTake = () => {
  const { t, i18n } = useTranslation();
  const tlVideoSrc = (i18n.language || 'de').startsWith('de') ? TL_VIDEO_DE : null;
  const tlVideoRef = useRef(null);
  const [tlPlaying, setTlPlaying] = useState(false);
  const playTlVideo = () => {
    if (tlVideoRef.current) {
      tlVideoRef.current.play();
      setTlPlaying(true);
    }
  };
  const tlVideo = tlVideoSrc && (
    <div className="htt-timeline__video">
      {/* #t=0.5 makes the browser paint a frame as the cover */}
      <video
        ref={tlVideoRef}
        src={`${tlVideoSrc}#t=0.5`}
        controls={tlPlaying}
        playsInline
        preload="metadata"
        onPause={(e) => { if (e.target.ended) setTlPlaying(false); }}
        onEnded={() => setTlPlaying(false)}
      />
      {!tlPlaying && (
        <button type="button" className="htt-timeline__cover" onClick={playTlVideo} aria-label={t(HTT_TL_VideoTitle)}>
          <span className="htt-timeline__cover-eyebrow">{t(HTT_TL_VideoEyebrow)}</span>
          <span className="htt-timeline__cover-title">{t(HTT_TL_VideoTitle)}</span>
          <span className="htt-timeline__cover-play">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M8 5v14l11-7L8 5z" fill="#103642" />
            </svg>
          </span>
        </button>
      )}
    </div>
  );
  const videoRef = useRef(null);
  const cardsRef = useRef(null);
  const stepsRef = useRef(null);
  const [activeStep, setActiveStep] = useState(0);
  const [doneActive, setDoneActive] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [activeCol, setActiveCol] = useState(3);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [faqCat, setFaqCat] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);
  const [ruleOpen, setRuleOpen] = useState(null);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  // Page scroll → detect which card is in the viewport and update the dot
  useEffect(() => {
    if (!isMobile) return;
    setActiveCol(0); // reset to Week 1 when entering mobile
    const onScroll = () => {
      const sticky = document.querySelector('.htt-tl-mobile__sticky');
      const stickyBottom = sticky ? sticky.getBoundingClientRect().bottom : 210;
      // trigger when card centre crosses the midpoint of the visible area
      const centre = (stickyBottom + window.innerHeight) / 2;
      const cards = document.querySelectorAll('.htt-tl-mobile__card');
      cards.forEach((card, i) => {
        const { top, bottom } = card.getBoundingClientRect();
        if (top <= centre && bottom >= centre) setActiveCol(i);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isMobile]);

  // Mobile ritual: progress rail fill + active step follow the scroll position
  useEffect(() => {
    if (!isMobile) return;
    const onScroll = () => {
      const el = stepsRef.current;
      if (!el) return;
      const { top, height } = el.getBoundingClientRect();
      const focus = window.innerHeight * 0.55;
      const progress = Math.min(1, Math.max(0, (focus - top) / height));
      el.style.setProperty('--htt-progress', progress.toFixed(3));
      const steps = el.querySelectorAll('.htt-ritual__step');
      let active = 0;
      steps.forEach((step, i) => {
        if (step.getBoundingClientRect().top <= focus) active = i;
      });
      setActiveStep(active);
      const done = el.querySelector('.htt-ritual__done');
      setDoneActive(!!done && done.getBoundingClientRect().top <= focus);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isMobile]);

  // Tap a dot → scroll that card into view
  const scrollToCard = (i) => {
    const cards = document.querySelectorAll('.htt-tl-mobile__card');
    if (cards[i]) cards[i].scrollIntoView({ behavior: 'smooth' });
  };

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setPlaying(true);
    }
  };

  return (
    <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", color: 'var(--navy, #103642)' }}>

      {/* ── Hero (compact, no colour background) ── */}
      <div className="htt-hero">
        <h1 className="htt-hero__title">{t(HTT_Headline)}</h1>
        <p className="htt-hero__sub">{t(HTT_Subhead)}</p>
        <div className="htt-hero__rules">
          <button
            type="button"
            className="htt-hero__rule htt-hero__rule--no"
            aria-expanded={ruleOpen === 'water'}
            aria-controls="htt-rule-why"
            onClick={() => setRuleOpen(o => (o === 'water' ? null : 'water'))}
          >
            {t(HTT_Rule_No)}
            <svg className="htt-hero__rule-chevron" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
              <path d="M2 3.5 L5 6.5 L8 3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <button
            type="button"
            className="htt-hero__rule htt-hero__rule--no"
            aria-expanded={ruleOpen === 'crunch'}
            aria-controls="htt-rule-crunch"
            onClick={() => setRuleOpen(o => (o === 'crunch' ? null : 'crunch'))}
          >
            {t(HTT_Rule_Crunch)}
            <svg className="htt-hero__rule-chevron" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
              <path d="M2 3.5 L5 6.5 L8 3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <span className="htt-hero__rule htt-hero__rule--yes">{t(HTT_Rule_Yes)}</span>
        </div>
        <div id="htt-rule-why" className={`htt-hero__why${ruleOpen === 'water' ? ' htt-hero__why--open' : ''}`}>
          <div className="htt-hero__why-inner">
            <p className="htt-hero__why-text">{t(HTT_Rule_Why)}</p>
            <p className="htt-hero__why-alt">{t(HTT_Rule_Alt)}</p>
          </div>
        </div>
        <div id="htt-rule-crunch" className={`htt-hero__why${ruleOpen === 'crunch' ? ' htt-hero__why--open' : ''}`}>
          <div className="htt-hero__why-inner">
            <p className="htt-hero__why-text">{t(HTT_Rule_CrunchWhy)}</p>
          </div>
        </div>
      </div>

      {/* ── Visual Ritual ── */}
      <section className="htt-ritual">
        <div className="htt-ritual__inner">
          <span className="htt-ritual__eyebrow">{t(HTT_StepsTitle)}</span>

          <div className="htt-ritual__steps" ref={stepsRef}>

            {[
              { num: '01', img: ritualImg2, labelKey: HTT_Step2_Label },
              { num: '02', img: ritualImg3, labelKey: HTT_Step3_Label },
              { num: '03', img: ritualImg4, labelKey: HTT_Step4_Label },
            ].map(({ num, img, labelKey }, i, arr) => (
              <React.Fragment key={num}>
                <div className={`htt-ritual__step${i === activeStep ? ' htt-ritual__step--active' : ''}`}>
                  <div className="htt-ritual__photo-wrap">
                    <img src={img} alt={t(labelKey)} className="htt-ritual__photo" />
                    <span className="htt-ritual__badge" aria-hidden="true">{i + 1}</span>
                  </div>
                  <div className="htt-ritual__step-num">{num}</div>
                  <div className="htt-ritual__step-of">{t(HTT_StepOf, { n: i + 1, total: arr.length })}</div>
                  <h3 className="htt-ritual__step-title">{t(labelKey)}</h3>
                </div>
                {i < arr.length - 1 && (
                  <div className="htt-ritual__connector" aria-hidden="true">
                    <svg width="28" height="14" viewBox="0 0 28 14" fill="none">
                      <path d="M0 7 H23" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                      <path d="M18 2 L24 7 L18 12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                )}
              </React.Fragment>
            ))}

            <div className={`htt-ritual__done${doneActive ? ' htt-ritual__done--active' : ''}`}>
              <span className="htt-ritual__done-check" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8.5 L6.5 12 L13 4.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              <span className="htt-ritual__done-text">{t(HTT_Done)}</span>
            </div>

          </div>

          <p className="htt-ritual__tagline">{t(HTT_Consistency)}</p>
        </div>

        {/* Video sits between steps and the CTA */}
        <div className="htt-ritual__video">
          <div className="htt-video-wrapper">
            <video
              ref={videoRef}
              src={howToTakeVideo}
              className="t-w-full t-h-full t-object-cover"
              controls
              playsInline
              preload="metadata"
            />
            {!playing && (
              <button
                onClick={handlePlay}
                className="t-absolute t-inset-0 t-flex t-flex-col t-items-center t-justify-center t-gap-3 t-bg-black/20 t-border-0 t-cursor-pointer"
                aria-label="Play video"
              >
                <span
                  className="t-flex t-items-center t-justify-center t-w-16 t-h-16 t-rounded-full"
                  style={{ background: '#F6E147' }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8 5v14l11-7L8 5z" fill="#103642" />
                  </svg>
                </span>
              </button>
            )}
          </div>
          <p className="htt-ritual__video-note">{t(HTT_VideoYoghurt)}</p>
        </div>

        {/* Daily check-in CTA */}
        <div className="htt-ritual__checkin">
          <div className="htt-ritual__checkin-copy">
            <p className="htt-ritual__checkin-eyebrow">{t(HTT_Ritual_CheckinEyebrow)}</p>
            <h3 className="htt-ritual__checkin-title">{t(HTT_Ritual_CheckinTitle)}</h3>
            <p className="htt-ritual__checkin-body">{t(HTT_Ritual_CheckinBody)}</p>
          </div>
          <a href={CHECKIN_URL} className="htt-ritual__checkin-btn">
            {t(HTT_Ritual_CheckinBtn)} →
          </a>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="htt-faq">
        <div className="htt-faq__inner">
          <span className="htt-faq__eyebrow">{t(HTT_FAQ_Eyebrow)}</span>
          <h2 className="htt-faq__headline">{t(HTT_FAQ_Headline)}</h2>

          <div className="htt-faq__tabs" role="tablist">
            {[HTT_FAQ_Cat_1, HTT_FAQ_Cat_2, HTT_FAQ_Cat_3, HTT_FAQ_Cat_4].map((catKey, i) => (
              <button
                key={i}
                role="tab"
                aria-selected={faqCat === i}
                className={`htt-faq__tab${faqCat === i ? ' htt-faq__tab--active' : ''}`}
                onClick={() => { setFaqCat(i); setOpenFaq(null); }}
              >
                {t(catKey)}
              </button>
            ))}
          </div>

          <div className="htt-faq__list">
            {FAQ_ITEMS.filter(item => item.cat === faqCat).map((item, idx) => {
              const key = `${faqCat}-${idx}`;
              const isOpen = openFaq === key;
              return (
                <div key={key} className={`htt-faq__item${isOpen ? ' htt-faq__item--open' : ''}`}>
                  <button
                    className="htt-faq__question"
                    onClick={() => setOpenFaq(isOpen ? null : key)}
                    aria-expanded={isOpen}
                  >
                    <span>{t(item.qKey)}</span>
                    <span className="htt-faq__icon" aria-hidden="true">{isOpen ? '−' : '+'}</span>
                  </button>
                  {isOpen && (
                    <div className="htt-faq__answer">
                      <p>{t(item.aKey)}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <p className="htt-faq__contact">
            {t(HTT_FAQ_Contact)} <a href="mailto:hi@weriise.co">hi@weriise.co</a>
          </p>
        </div>
      </section>

      {/* ── What to expect timeline ── */}
      <section className="htt-timeline">
        {isMobile ? (
          /* ── Mobile: sticky graph + swipeable single card ── */
          <div className="htt-tl-mobile">

            {/* Sticky: header text + graph stays pinned while cards scroll underneath */}
            <div className="htt-tl-mobile__sticky">
              <div className="htt-tl-mobile__header">
                <span className="htt-timeline__eyebrow">{t(HTT_TL_Eyebrow)}</span>
                <h2 className="htt-timeline__headline">{t(HTT_TL_Headline)}</h2>
              </div>
              {/* viewBox 0 0 400 150 fills the mobile width with no horizontal compression */}
              <div className="htt-tl-mobile__graph">
                <svg viewBox="0 0 400 150" fill="none" aria-hidden="true" preserveAspectRatio="none" style={{width:'100%',height:'100%',display:'block'}}>
                  <defs>
                    <linearGradient id="htt-tl-fill-m" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="rgba(17,109,110,0.13)" />
                      <stop offset="100%" stopColor="rgba(17,109,110,0)" />
                    </linearGradient>
                  </defs>
                  <line x1="0" y1="141" x2="400" y2="141" stroke="rgba(16,54,66,0.08)" strokeWidth="1" />
                  <path d="M 50 135 C 100 135 128 132 150 129 C 195 126 216 104 250 90 C 284 73 318 29 350 15 L 350 141 L 50 141 Z" fill="url(#htt-tl-fill-m)" />
                  <path d="M 50 135 C 100 135 128 132 150 129 C 195 126 216 104 250 90 C 284 73 318 29 350 15" stroke="var(--teal,#116D6E)" strokeWidth="2" strokeLinecap="round" />
                  {TL_DOTS_MOBILE.map((dot, i) => (
                    <circle key={i} cx={dot.cx} cy={dot.cy} r="4"
                      fill={activeCol === i ? 'var(--teal,#116D6E)' : 'rgba(16,54,66,0.18)'}
                      style={{transition:'fill 0.3s'}} />
                  ))}
                  <circle className="htt-timeline__dot-highlight"
                    cx={TL_DOTS_MOBILE[activeCol].cx} cy={TL_DOTS_MOBILE[activeCol].cy}
                    r="7" fill="var(--butter,#F6E147)" stroke="var(--teal,#116D6E)" strokeWidth="1.5" />
                </svg>
              </div>
            </div>

            {/* Cards in normal page flow — page scroll drives the dot, no scroll trap */}
            <div className="htt-tl-mobile__cards">
              {TL_MILESTONES.map((m, i) => (
                <div key={i} className={`htt-tl-mobile__card${activeCol === i ? ' htt-tl-mobile__card--active' : ''}`}>
                  <span className="htt-timeline__period">{t(m.period)}</span>
                  <h3 className="htt-timeline__title">{t(m.title)}</h3>
                  <p className="htt-timeline__body">{t(m.body)}</p>
                </div>
              ))}
            </div>

            {tlVideo}

          </div>
        ) : (
          /* ── Desktop: video left, vertical curve + milestones right ── */
          <div className="htt-timeline__inner">
            <span className="htt-timeline__eyebrow">{t(HTT_TL_Eyebrow)}</span>
            <h2 className="htt-timeline__headline">{t(HTT_TL_Headline)}</h2>
            <div className="htt-timeline__layout">
              {tlVideo}
              <div className="htt-timeline__vertical" onMouseLeave={() => setActiveCol(3)}>
                {/* viewBox matches rendered px (120 x 544) so dots stay circular; rows are 136px each */}
                <svg className="htt-timeline__vgraph" viewBox="0 0 120 544" fill="none" aria-hidden="true">
                  <defs>
                    <linearGradient id="htt-tl-fill-v" x1="0" y1="0" x2="1" y2="0">
                      <stop offset="0%" stopColor="rgba(17,109,110,0)" />
                      <stop offset="100%" stopColor="rgba(17,109,110,0.13)" />
                    </linearGradient>
                  </defs>
                  <line x1="8" y1="0" x2="8" y2="544" stroke="rgba(16,54,66,0.08)" strokeWidth="1" />
                  <path d="M 14 68 C 16 136 20 170 24 204 C 34 265 40 285 52 340 C 66 400 90 450 104 476 L 8 476 L 8 68 Z" fill="url(#htt-tl-fill-v)" />
                  <path d="M 14 68 C 16 136 20 170 24 204 C 34 265 40 285 52 340 C 66 400 90 450 104 476" stroke="var(--teal,#116D6E)" strokeWidth="1.8" strokeLinecap="round" />
                  {TL_DOTS_V.map((dot, i) => (
                    <circle key={i} cx={dot.cx} cy={dot.cy} r="3.5"
                      fill={activeCol === i ? 'var(--teal,#116D6E)' : 'rgba(16,54,66,0.18)'}
                      style={{transition:'fill 0.25s'}} />
                  ))}
                  <circle className="htt-timeline__dot-highlight"
                    cx={TL_DOTS_V[activeCol].cx} cy={TL_DOTS_V[activeCol].cy}
                    r="6" fill="var(--butter,#F6E147)" stroke="var(--teal,#116D6E)" strokeWidth="1.5" />
                </svg>
                <div className="htt-timeline__rows">
                  {TL_MILESTONES.map(({ period, title, body }, i) => (
                    <div key={i} className={`htt-timeline__row${activeCol === i ? ' htt-timeline__row--active' : ''}`} onMouseEnter={() => setActiveCol(i)}>
                      <span className="htt-timeline__period">{t(period)}</span>
                      <h3 className="htt-timeline__title">{t(title)}</h3>
                      <p className="htt-timeline__body">{t(body)}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      {/* ── Founders message ── */}
      <section
        className="t-py-16 t-px-4"
        style={{ background: 'var(--navy, #103642)', color: '#F9F9F9' }}
      >
        <div className="t-max-w-[640px] t-mx-auto t-flex t-flex-col md:t-flex-row t-items-center t-gap-10">
          <img
            src={AleAndPaul}
            alt="Paul-Antoine & Alessandro"
            className="t-w-40 t-h-40 md:t-w-48 md:t-h-48 t-rounded-full t-object-cover t-flex-shrink-0"
          />
          <div>
            <p
              className="!t-m-0 t-text-xs t-uppercase t-tracking-widest t-font-semibold t-mb-4 t-opacity-50"
              style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
            >
              {t(HTT_FoundersEyebrow)}
            </p>
            <p
              className="!t-m-0 t-text-base t-leading-relaxed t-mb-6 t-opacity-90"
              style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
            >
              {t(HTT_FoundersMessage)}
            </p>
            <p
              className="!t-m-0 t-text-sm t-font-semibold t-opacity-60"
              style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
            >
              — {t(HTT_FoundersSignature)}
            </p>
          </div>
        </div>
      </section>

      {/* ── Riise Concept ── */}
      <section className="htt-concept">
        <div className="htt-concept__inner">
          <span className="htt-concept__eyebrow">{t(HTT_Concept_Eyebrow)}</span>
          <h2 className="htt-concept__headline">{t(HTT_Concept_Headline)}</h2>

          {/* Brain split */}
          <div className="htt-brain">
            <div className="htt-brain__split">
              <div className="htt-brain__card htt-brain__card--rational">
                <span className="htt-brain__tag">{t(HTT_Brain_TagLeft)}</span>
                <div className="htt-brain__pct">{t(HTT_Brain_PctLeft)}</div>
                <h3 className="htt-brain__card-title">{t(HTT_Brain_TitleLeft)}</h3>
                <p className="htt-brain__card-body">{t(HTT_Brain_BodyLeft)}</p>
              </div>
              <div className="htt-brain__vs">
                <span className="htt-brain__vs-label">vs</span>
                <span className="htt-brain__vs-line" />
              </div>
              <div className="htt-brain__card htt-brain__card--irrational">
                <span className="htt-brain__tag">{t(HTT_Brain_TagRight)}</span>
                <div className="htt-brain__pct">{t(HTT_Brain_PctRight)}</div>
                <h3 className="htt-brain__card-title">{t(HTT_Brain_TitleRight)}</h3>
                <p className="htt-brain__card-body">{t(HTT_Brain_BodyRight)}</p>
              </div>
            </div>
            <div className="htt-brain__insight">
              <div className="htt-brain__insight-icon">→</div>
              <p className="htt-brain__insight-text">{t(HTT_Brain_Insight)}</p>
            </div>
          </div>

          {/* Habit loop */}
          <div className="htt-habit">
            <span className="htt-habit__eyebrow">{t(HTT_Habit_Eyebrow)}</span>
            <h3 className="htt-habit__headline">{t(HTT_Habit_Headline)}</h3>
            <p className="htt-habit__intro">{t(HTT_Habit_Intro)}</p>
            <div className="htt-habit__wheel-wrapper">
              {/*
                Ring: cx=450 cy=430 r=280  viewBox 0 0 900 800
                Nodes: CUE (450,150) · ROUTINE (692,570) · REWARD (208,570)
                Arc offset: 22° so paths clear card edges cleanly.
              */}
              <svg
                className="htt-habit__wheel-svg"
                viewBox="0 0 900 800"
                fill="none"
                aria-hidden="true"
              >
                <defs>
                  <marker id="htt-arr" markerWidth="8" markerHeight="6" refX="7" refY="3" orient="auto">
                    <polygon points="0 0, 8 3, 0 6" fill="rgba(16,54,66,0.28)" />
                  </marker>
                </defs>
                {/* Dashed ring */}
                <circle cx="450" cy="430" r="280" stroke="rgba(16,54,66,0.07)" strokeWidth="1.5" fill="none" strokeDasharray="5 8" />
                {/* Node halos */}
                <circle cx="450" cy="150" r="6" fill="rgba(16,54,66,0.12)" />
                <circle cx="692" cy="570" r="6" fill="rgba(16,54,66,0.12)" />
                <circle cx="208" cy="570" r="6" fill="rgba(16,54,66,0.12)" />
                {/* CUE→ROUTINE: 292°→8° clockwise */}
                <path d="M 554.7 170.4 A 280 280 0 0 1 727.3 468.9"
                  stroke="rgba(16,54,66,0.22)" strokeWidth="1.5" strokeDasharray="5 4" markerEnd="url(#htt-arr)" />
                {/* ROUTINE→REWARD: 52°→128° clockwise */}
                <path d="M 622.3 650.6 A 280 280 0 0 1 277.7 650.6"
                  stroke="rgba(16,54,66,0.22)" strokeWidth="1.5" strokeDasharray="5 4" markerEnd="url(#htt-arr)" />
                {/* REWARD→CUE: 172°→248° clockwise */}
                <path d="M 172.7 468.9 A 280 280 0 0 1 345.3 170.4"
                  stroke="rgba(16,54,66,0.22)" strokeWidth="1.5" strokeDasharray="5 4" markerEnd="url(#htt-arr)" />
              </svg>

              <div className="htt-habit__grid">
                <div className="htt-habit__step">
                  <div className="htt-habit__step-num">{t(HTT_Habit_1_Num)}</div>
                  <h4 className="htt-habit__step-title">{t(HTT_Habit_1_Title)}</h4>
                  <p className="htt-habit__step-body">{t(HTT_Habit_1_Body)}</p>
                  <div className="htt-habit__step-note">{t(HTT_Habit_1_Note)}</div>
                </div>
                <div className="htt-habit__step">
                  <div className="htt-habit__step-num">{t(HTT_Habit_2_Num)}</div>
                  <h4 className="htt-habit__step-title">{t(HTT_Habit_2_Title)}</h4>
                  <p className="htt-habit__step-body">{t(HTT_Habit_2_Body)}</p>
                  <div className="htt-habit__step-note">{t(HTT_Habit_2_Note)}</div>
                </div>
                <div className="htt-habit__step htt-habit__step--reward">
                  <div className="htt-habit__step-num">{t(HTT_Habit_3_Num)}</div>
                  <h4 className="htt-habit__step-title">{t(HTT_Habit_3_Title)}</h4>
                  <p className="htt-habit__step-body">{t(HTT_Habit_3_Body)}</p>
                  <div className="htt-habit__step-note">{t(HTT_Habit_3_Note)}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Support footer ── */}
      <section className="t-py-10 t-px-4 t-text-center" style={{ background: '#F9F9F9' }}>
        <p
          className="!t-m-0 t-text-sm t-opacity-50"
          style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
        >
          {t(HTT_Support)}
        </p>
      </section>

    </div>
  );
};

export default HowToTake;
